module.exports = __webpack_public_path__ + "img/img-a6e0f36d.3ac2c5f7.png";